"use client";

import { Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import * as myApi from "../Api";

const LeftSidebar = ({ user, toggleActive }) => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location
  
  // Set main page based on user role
  const mainPage = user.role === 'admin' ? '/dashboard/' : '/paper/list/';

  return (
    <>
      <div className="sidebar-area">
        <div className="logo position-relative">
          <Link
            to={mainPage}
            className="d-block text-decoration-none position-relative"
          >
            <img
              src="/images/ejavec/ejavec-logo.svg"
              alt="logo-icon"
              width={80}
              height={26}
            />
            <span className="logo-text fw-bold text-dark text-sm"></span>
          </Link>
          <button
            className="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
            onClick={toggleActive}
          >
            <i className="material-symbols-outlined fs-24">close</i>
          </button>
        </div>

        <div className="sidebar-menu" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <div className="menu-title small text-uppercase">
              <span className="menu-title-text">MAIN</span>
            </div>

            <ul className={user.role === "admin" ? "sub-menu" : "sub-menu d-none"}>
              <li className="menu-item">
                <Link
                  to="/dashboard/"
                  className={`menu-link ${
                    pathname === "/dashboard/" ? "active" : ""
                  }`}
                >
                  Dashboard
                </Link>
              </li>
            </ul>


            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <i className="material-symbols-outlined">two_pager</i>
                  <span className="title">Papers</span>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="sub-menu">
                    <li className={user.role === "admin" ? "menu-item d-none" : "menu-item"}>
                      <Link
                        to="/paper/add/"
                        className={`menu-link ${
                          pathname === "/paper/add/" ? "active" : ""
                        }`}
                      >
                        Create Paper
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to="/paper/list/"
                        className={`menu-link ${
                          pathname === "/paper/list/" ? "active" : ""
                        }`}
                      >
                        List Paper
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <i className="material-symbols-outlined">account_box</i>
                  <span className="title">Profile</span>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="sub-menu">
                    <li className="menu-item">
                      <Link
                        to="/profile"
                        className={`menu-link ${
                          pathname === "/profile" ? "active" : ""
                        }`}
                      >
                        User Profile
                      </Link>
                    </li>

                    <li className="menu-item">
                      <Link
                        to="/profile/teams"
                        className={`menu-link ${
                          pathname === "/profile/teams" ? "active" : ""
                        }`}
                      >
                        Teams
                      </Link>
                    </li>

                    <li className="menu-item">
                      <Link
                        to="/profile/projects"
                        className={`menu-link ${
                          pathname === "/profile/projects" ? "active" : ""
                        }`}
                      >
                        Projects
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item> */}

            </Accordion>
          </div>

          <hr className="my-3" />
          <div className="menu-title small text-uppercase">
            <span className="menu-title-text">DOCUMENTS</span>
          </div>
          <ul className="sub-menu">
            <li className="menu-item">
              <button
                className="menu-link border-0 bg-transparent w-100 text-start d-flex align-items-center gap-2 py-2"
                onClick={() => window.open(`${myApi.baseUrl}/download/document?doc=author-guidelines`, '_blank')}
                title="Unduh Panduan Penulis"
              >
                <i className="material-symbols-outlined">description</i>
                <span>Panduan Penulis</span>
              </button>
            </li>
            <li className="menu-item">
              <button
                className="menu-link border-0 bg-transparent w-100 text-start d-flex align-items-center gap-2 py-2"
                onClick={() => window.open(`${myApi.baseUrl}/download/document?doc=lembar-pengesahan`, '_blank')}
                title="Unduh Lembar Pengesahan"
              >
                <i className="material-symbols-outlined">fact_check</i>
                <span>Lembar Pengesahan</span>
              </button>
            </li>
            <li className="menu-item">
              <button
                className="menu-link border-0 bg-transparent w-100 text-start d-flex align-items-center gap-2 py-2"
                onClick={() => window.open(`${myApi.baseUrl}/download/document?doc=surat-pernyataan`, '_blank')}
                title="Unduh Surat Pernyataan"
              >
                <i className="material-symbols-outlined">assignment</i>
                <span>Surat Pernyataan</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default LeftSidebar;
